module.exports = __webpack_public_path__ + "media/images/external-link-f02864c0e12a21ddc73639414deb4de7.svg";